import { render, staticRenderFns } from "./WnlUnitIcon.vue?vue&type=template&id=5f6c1ebc&scoped=true&"
import script from "./WnlUnitIcon.vue?vue&type=script&lang=js&"
export * from "./WnlUnitIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f6c1ebc",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
